import React from "react"
import { Badge, BadgeProps, HStack, Flex } from "@chakra-ui/react"

import useLearnPage from "@hooks/useLearnPage"

export interface LearnPageBadgesProps {
  badgeProps?: BadgeProps
}

const LearnPageBadges = ({ badgeProps }: LearnPageBadgesProps) => {
  const { item } = useLearnPage()

  return (
    <Flex>
      {item.categories?.length ? (
        item.categories.map(category => (
          <HStack mr={2} key={category?.handle}>
            <Badge size="sm" {...badgeProps}>
              {category?.title}
            </Badge>
          </HStack>
        ))
      ) : (
        <HStack>
          <Badge key={item.category?.handle} size="sm" {...badgeProps}>
            {item.category?.title}
          </Badge>
        </HStack>
      )}
    </Flex>
  )
}

export default LearnPageBadges
